<template>
    <rkm-overlay>
        <rkm-layout-body :title="`${id ? 'Visualização' : 'Cadastro'} de requisição`">
            <template v-slot:actions>
                <rkm-button
                    @click.stop="handleExit"
                    color="danger"
                >
                    Sair
                </rkm-button>

                <rkm-button
                    v-if="!id"
                    @click="$refs.Form.save()"
                    color="primary"
                >
                    Salvar
                </rkm-button>

                <template v-else-if="model && model.possuiNovoEnvio">
                    <rkm-button
                        v-if="model.temRecebimentoParcial"
                        @click="$refs.Form.saveRetorno(false)"
                        color="success"
                    >
                        Salvar recebimento parcial
                    </rkm-button>

                    <rkm-button
                        v-else
                        @click="$refs.Form.saveRetorno(true)"
                        color="success"
                    >
                        Finalizar
                    </rkm-button>
                </template>
            </template>

            <rkm-layout-content>
                <Form
                    :id="id"
                    :key="formKey"
                    @model-load="model = $event"
                    @save="handleSave"
                    @partial-save="formKey++"
                    ref="Form"
                />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import Form from '@/components/almoxarifado/requisicao-abertura-fechamento/Form'

// Others.
import { mapActions } from 'vuex'

export default {
    components: { Form },
    created() {

        if (!this.id) {

            this.setShowExitFormConfirmation()
        }
    },
    data: () => ({
        model: null,
        formKey: 1,
    }),
    methods: {
        ...mapActions(['setShowExitFormConfirmation', 'unsetShowExitFormConfirmation']),
        handleExit() {

            this.redirectToList()
        },
        handleSave() {

            this.unsetShowExitFormConfirmation()
            this.redirectToList()
        },
        redirectToList() {

            this.$router.push({ name: 'almoxarifado-requisicao-abertura-fechamento-index' })
        }
    },
    props: {
        id: { type: Number, default: null }
    },
    watch: {
        model(model) {

            if (model && model.possuiNovoEnvio) {

                this.setShowExitFormConfirmation()
            }
        }
    }
}
</script>